import {createReducer} from '../utils';
import {
  ADMIN_SIGNED_IN,
  LOGGED_IN,
  GET_INVITATION_DATA_REQUEST,
  GET_INVITATION_DATA_SUCCESS,
  ON_CODE_ERROR,
  SIGNUP_REQUEST,
  LOGIN_REQUEST,
  AUTH_SUCCESS,
  ON_API_ERROR,
  ON_SIGN_OUT,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_REQUEST,
  CLEAR_AUTH_STATUSES,
  CLEAR_AUTH_STATUSES_STAY_SIGNED,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_CODE_SUCCESS,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_REQUEST,
  SAVE_LANGUAGE,
} from '../actions/types';

const initialState = {
  isAuthenticated: false,
  token: null,
  codeError: false,
  isFetchingCode: false,
  inProgress: false,
  profile: undefined,
};

const authReducer = createReducer(initialState, {
  [GET_INVITATION_DATA_REQUEST]: (state) => ({
    ...state,
    isFetchingCode: true,
  }),
  [GET_INVITATION_DATA_SUCCESS]: (state, {user}) => ({
    ...state,
    isFetchingCode: false,
    codeError: false,
    profile: user,
  }),
  [ON_CODE_ERROR]: (state) => ({
    ...state,
    codeError: true,
    isFetchingCode: false,
    inProgress: false,
  }),
  [SIGNUP_REQUEST]: (state) => ({...state, inProgress: true}),
  [LOGIN_REQUEST]: (state) => ({...state, inProgress: true}),
  [FORGOT_PASSWORD_REQUEST]: (state) => ({...state, inProgress: true}),
  [RESET_PASSWORD_REQUEST]: (state) => ({...state, inProgress: true}),
  [FORGOT_PASSWORD_SUCCESS]: (state) => ({
    ...state,
    inProgress: false,
    forgotSuccess: true
  }),
  [RESET_PASSWORD_CODE_SUCCESS]: (state, {user}) => ({...state, profile: user}),
  [AUTH_SUCCESS]: (state, {token, user}) => ({
    ...state,
    inProgress: false,
    isAuthenticated: true,
    token,
    profile: user,
    role: user.role,
  }),
  [ADMIN_SIGNED_IN]: (state) => ({
    ...state,
    isAuthenticated: true,
  }),
  [LOGGED_IN]: (state, {authData}) => ({
    ...state,
    ...authData,
    isAuthenticated: true,
  }),
  [CLEAR_AUTH_STATUSES]: () => ({
    ...initialState,
    inProgress: false,
    isFetchingCode: false,
    forgotSuccess: false,
    codeError: false,
    forgotError: false
  }),
  [CLEAR_AUTH_STATUSES_STAY_SIGNED]: (state) => ({
    ...state,
    inProgress: false,
    isFetchingCode: false,
    forgotSuccess: false,
    codeError: false,
    forgotError: false
  }),
  [UPDATE_PROFILE_REQUEST]: (state) => ({
    ...state,
    inProgress: true
  }),
  [UPDATE_PROFILE_SUCCESS]: (state, {profile}) => ({
    ...state,
    inProgress: false,
    profile: {...state.profile, ...profile}
  }),
  [ON_API_ERROR]: (state) => ({
    ...state,
    isFetchingCode: false,
    inProgress: false,
    forgotSuccess: false
  }),
  [ON_SIGN_OUT]: () => initialState,
  [SAVE_LANGUAGE]: (state, {lng}) => {

    return {
      ...state,
      language: lng,
    }
  }
});

export default authReducer;
